import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDownload = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={13}
    fill="none"
    viewBox="0 0 12 13"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5.996 9.688a.756.756 0 0 1-.281-.053.691.691 0 0 1-.236-.156L2.521 6.521a.688.688 0 0 1-.219-.53.788.788 0 0 1 .77-.762.73.73 0 0 1 .532.23L5.25 7.124V.75c0-.213.071-.39.214-.534A.72.72 0 0 1 5.996 0c.21 0 .39.072.535.216A.72.72 0 0 1 6.75.75v6.375l1.667-1.667a.676.676 0 0 1 .527-.218.808.808 0 0 1 .545.24.745.745 0 0 1-.01 1.062L6.521 9.479a.756.756 0 0 1-.525.208M1.494 13c-.413 0-.765-.147-1.056-.44A1.45 1.45 0 0 1 0 11.5v-.75c0-.213.071-.39.214-.534A.72.72 0 0 1 .746 10c.21 0 .39.072.535.216a.72.72 0 0 1 .219.534v.75h9v-.75c0-.213.072-.39.214-.534a.72.72 0 0 1 .532-.216c.21 0 .39.072.535.216a.72.72 0 0 1 .219.534v.75c0 .412-.147.766-.44 1.06-.295.293-.648.44-1.06.44z"
    />
  </svg>
);
export default SvgDownload;
